/**
 * Initials for an avatar fallback.
 *
 * Extracted from `Avatar.tsx` (#3123 round 3) rather than written fresh. The
 * landing page renders a DEMO face whose whole purpose is to look like the real
 * Avatar; a second, subtly different rule there would make the mock a claim
 * about the app that the app does not honor — the same class of overstatement
 * as the four-color mock this rebuild already removed.
 *
 * The behavior is Avatar's, unchanged and deliberately literal: split on single
 * spaces, take each part's first character, uppercase, and keep at most two.
 * Empty parts from repeated spaces contribute nothing, so extra whitespace is
 * harmless without needing to be trimmed.
 */
export function initialsOf(name: string): string {
  return name
    .split(' ')
    .map((part) => part.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
